import React, { useEffect, useState } from 'react'
import logo from '../../superadmin/assets/invoice_logo.png';
import { Button, Stack, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import '../../superadmin/styles/pages/auth.css';
import { useParams } from 'react-router-dom';
import instance from '../../utils/Api';

const TAX_RATE = 0.07;

function ccyFormat(num) {
  return `${num.toFixed(2)}`;
}

function priceRow(qty, unit) {
  return qty * unit;
}

function createRow(desc, qty, unit) {
  const price = priceRow(qty, unit);
  return { desc, qty, unit, price };
}

function subtotal(items) {
  return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
}

const rows = [
  createRow('Paperclips (Box)', 100, 1.15),
  createRow('Paper (Case)', 10, 45.99),
  createRow('Waste Basket', 2, 17.99),
];

const invoiceSubtotal = subtotal(rows);
const invoiceTaxes = TAX_RATE * invoiceSubtotal;
const invoiceTotal = invoiceTaxes + invoiceSubtotal;


const PdfTemplate = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [products, setProducts] = useState([]);

  function priceRow(qty, unit) {
    return qty * unit;
  }

  function createRow(desc, qty, unit) {
    const price = priceRow(qty, unit);
    return { desc, qty, unit, price };
  }

  function subtotal(items) {
    return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
  }
  const invoiceSubtotal = subtotal(products);
  const getAttence = async () => {
    try {
      const response = await instance.get(`/Transactions/getTransactionById?transaction_id=${id}`);
      console.log(response);
      setData(response.data.data);

      const products = response?.data?.data?.products?.map((data) =>
        createRow(
          data?.product_id?.product_name,
          data?.quantity,
          data?.product_id?.price
        )
      );

      setProducts(products);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAttence();
  }, [id]);
  console.log(data);
  console.log(products);

  return (
    <div className='invoice-main'>
      <div className='template_main'>
        <Stack direction={'row'}>
          <img src={logo} alt="Invoice Logo" />
          <Stack direction={'row'} spacing={2} className='template_main_date' sx={{ alignItems: 'center' }}>
            <Typography variant='body1' >Invoice Date</Typography>
            <Typography variant='body1' ><b>6 March, 2023</b></Typography>
          </Stack>
        </Stack>
        <Stack>

        </Stack>
        <div className='employee-table'>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="spanning table">
              <TableHead>
                <TableRow>
                  <TableCell >
                    <div className='employee-name'>
                      Description
                    </div>
                  </TableCell>
                  <TableCell align="right"><div className='employee-name'>Quantity</div></TableCell>
                  <TableCell align="right"><div className='employee-name'>Price</div></TableCell>
                  <TableCell align="right"><div className='employee-name'>Amount</div></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map((row) => (
                  <TableRow key={row.desc}>
                    <TableCell>{row.desc}</TableCell>
                    <TableCell align="right">{row.qty}</TableCell>
                    <TableCell align="right">{row.unit}</TableCell>
                    <TableCell align="right">{ccyFormat(row.price)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell rowSpan={3} />
                  <TableCell colSpan={2}>Total Amount</TableCell>
                  <TableCell align="right">{ccyFormat(invoiceSubtotal)}</TableCell>
                </TableRow>
                {/* <TableRow>
                <TableCell>Tax</TableCell>
                <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell>
                <TableCell align="right">{ccyFormat(invoiceTaxes)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>Total</TableCell>
                <TableCell align="right">{ccyFormat(invoiceTotal)}</TableCell>
              </TableRow> */}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className='button-print'>
          <Button variant="outlined">Print</Button>
        </div>
      </div>
    </div>
  )
}

export default PdfTemplate